import React, { useState } from 'react'
import './Signature.css'
import SignaturePad from 'react-signature-canvas'
import ColorPicker from '../../../utilities/colorTools/ColorPicker'
//svg
import SvgHorizontalArrow from '../../../svgIcons/SvgHorizontalArrow'
import SvgVerticalArrow from '../../../svgIcons/SvgVerticalArrow'

import SvgPalette from '../../../svgIcons/SvgPalette'
import SvgEraser from '../../../svgIcons/SvgEraser'
import SvgSave from '../../../svgIcons/SvgSave'
//Redux
import { createSketch, closeSketchModal } from '../../../redux'
import { useDispatch } from 'react-redux'
//MUI
import HighlightOffIcon from '@material-ui/icons/HighlightOff'

function SignPad() {
  const dispatch = useDispatch()

  const MINIMUM_STROKE_WEIGHT = 1
  const MAXIMUM_STROKE_WEIGHT = 10

  const [signPad, setSignPad] = useState({})
  const [signWeight, setSignWeight] = useState(3)
  const [color, setColor] = useState('black')

  const getColor = (color) => {
    const rgbValue = `rgb(${color.r},${color.g},${color.b})`
    setColor(rgbValue)
  }

  const increaseWeight = () => {
    if (signWeight < MAXIMUM_STROKE_WEIGHT) setSignWeight((prevWeight) => prevWeight + 1)
  }

  const decreaseWeight = () => {
    if (signWeight > MINIMUM_STROKE_WEIGHT) setSignWeight((prevWeight) => prevWeight - 1)
  }

  const clear = () => {
    signPad.clear()
  }

  const save = () => {
    if (!signPad.isEmpty()) {
      dispatch(createSketch(signPad.getTrimmedCanvas().toDataURL('image/png')))
      exit()
    }
  }

  const exit = () => {
    dispatch(closeSketchModal())
  }

  return (
    <div className='signpad-container '>
      <div className='signpad-tool-container'>
        <HighlightOffIcon className='signpad-close-btn' onClick={exit} />

        <div className='signpad-tool'>
          <div className='signpad-stroke-style '>
            <span role='img' aria-label='minus' className='signpad-stroke-manager-icon no-select ' onClick={decreaseWeight}>
              &#10134;
            </span>
            <span className='sign-weight'>
              {signWeight}
              <SvgVerticalArrow className='stroke-vertical-arrow' />
            </span>
            <span role='img' aria-label='plus' className='signpad-stroke-manager-icon no-select ' onClick={increaseWeight}>
              &#10133;
            </span>
          </div>
          <SvgHorizontalArrow className='stroke-horizontal-arrow' />
        </div>

        <div className='signpad-tool'>
          <ColorPicker getColor={getColor} color={color}>
            <SvgPalette color={color} />
          </ColorPicker>
        </div>

        <div className='signpad-tool' onClick={clear}>
          <SvgEraser />
        </div>

        <div className='signpad-tool no-select' style={{ color: 'white' }}>
          Draw as big as possible to get high quality signature.
        </div>

        <div className='signpad-tool' onClick={save}>
          <SvgSave />
        </div>
      </div>
      <div className='signpad-style'>
        <SignaturePad
          canvasProps={{ className: 'signPad-canva' }}
          minWidth={signWeight}
          maxWidth={signWeight + 5}
          dotSize={signWeight}
          penColor={color}
          minDistance={1}
          ref={(ref) => {
            setSignPad(ref)
          }}
        />
      </div>
    </div>
  )
}

export default SignPad
